import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { ComboService } from '../../../Model/Combo/combo.service';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { RouteService } from '../../../Model/Route/route.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-route-form',
  standalone: true,
  imports: [FormsModule, CommonModule, NgSelectModule, LoaderComponent],
  templateUrl: './route-form.component.html',
  styleUrl: './route-form.component.scss'
})
export class RouteFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() id!: number;
  @Input() Code!: string;
  @Input() Name!: string;
  @Input() ClusterId!: any;
  @Input() SiteOwnerId !: any;

  ClusterLoad: any[] = []
  SiteOwnerLoad: any[] = []
  Detail = {
    SelectType: 'I',
    ESS_RouteMasterId: 0,
    ESS_ClusterID: null as any,
    ESS_SiteOwnerID: null,
    RouteName: null as any,
    UserId: 0,
    Code: null as any
  }
  constructor(
    private modalService: NgbModal,
    private toast: ToastService,
    private combo: ComboService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private route: RouteService,
  ) {
    this.common.getPageRights();
    // this.common.PageRight.IsView = true;
    // this.common.PageRight.IsAdd = true;
    // this.common.PageRight.IsDelete = true;
    // this.common.PageRight.IsEdit = true;
    // this.common.PageRight.IsPrint = true;

    this.Detail.ESS_RouteMasterId = this.id
  }

  ngOnInit(): void {
    this.ComboLoad('SiteOwner');
    this.ComboLoad('ClusterMaster');
    if (this.id > 0) {
      this.Detail.SelectType = 'U'
      this.Detail.ESS_RouteMasterId = this.id;
      this.Detail.Code = this.Code;
      this.Detail.RouteName = this.Name;
      this.Detail.ESS_ClusterID = this.ClusterId
      this.Detail.ESS_SiteOwnerID = this.SiteOwnerId
    }
  }

  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.isDisabled = true
    this.combo.ComboLoad({
      'Combotype': Combotype,
      // 'EmpType': 'front'
    }).subscribe({
      next: (response) => {
        if (Combotype == 'SiteOwner') {
          this.SiteOwnerLoad = response.ComboLoad;
        } else if (Combotype == 'ClusterMaster') {
          this.ClusterLoad = response.ComboLoad;
        }
        this.isDisabled = false
      },
      complete: () => {
        this.isDisabled = false
      },
      error: (error) => {
      },
    });
  }

  async Save() {
    await this.common.getPageRights();
    console.log(this.Detail);
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want save?'
    modalRef.result.then((result: any) => {
      if ((this.id == 0 && this.common.PageRight.IsAdd) || (this.id > 0 && this.common.PageRight.IsEdit)) {
        if (result) {
          this.isDisabled = true;
          this.Detail.ESS_RouteMasterId = this.id
          this.route.ESS_RouteMaster_Insert(this.Detail).subscribe({
            next: (response) => {
              if (response.Error_Code == '599' || response.Error_Code == '600') {
                this.activeModal.close(true);
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              }
              else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });
  }

  close() {
    this.activeModal.close();
  }

}
